module.exports = __webpack_public_path__ + "img/IMG_6953.49e7c436.webp";